import React, { useEffect } from 'react';
import dayjs from 'dayjs';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';

import Table from '~components/molecules/Table';
import ActionButton from '~components/atoms/ActionButton';

import UtilFunctions from '~utils/functions';
import { ModuleEnum, PermissionsEnum, ProjectAccStatusEnum } from '~utils/enums';

import * as Styles from './_projectManagementTable.module.scss';

const ProjectManagementTable = () => {
    const { Misc: { renderProjectStatusChip, dateTimeFormat } } = UtilFunctions;

    const projectListingIndex = useAppSelector(state => state.project.projectListing.index);

    useEffect(() => {
        dispatch(combinedActions.projectGetProjectListingAttempt());
    }, [projectListingIndex]);

    const isLoading = useAppSelector(state => state.project.loadings.getProjectListing);
    const projectListing = useAppSelector(state => state.project.projectListing.data);
    const userAccess = useAppSelector(state => state.auth.userDetails.access);

    const dispatch = useAppDispatch();

    const setprojectDetailsModalIsOpen = (isOpen: boolean) => dispatch(combinedActions.projectSetProjectDetailsModalIsOpen(isOpen));
    const setProjectStatusModalIsOpen = (isOpen: boolean) => dispatch(combinedActions.projectSetStatusProjectModalIsOpen(isOpen));
    const setIsEditing = (isEditing: boolean) => dispatch(combinedActions.projectSetProjectDetailsModalIsEditing(isEditing));
    const getProjectDetails = (projectId: number) => dispatch(combinedActions.projectGetProjectDetailsAttempt({ projectId }));

    const hasEditAccess = !!userAccess.find(item => item.permission === PermissionsEnum.Edit)?.modules.find(module => module === ModuleEnum.Project);

    const handleEditprojectClick = (projectId: number) => {
        setIsEditing(true);
        setprojectDetailsModalIsOpen(true);
        getProjectDetails(projectId);
    };

    const handleStatusProjectClick = (projectId: number) => {
        setProjectStatusModalIsOpen(true);
        setIsEditing(true);
        getProjectDetails(projectId);
    };

    const hasAccess = (permission: PermissionsEnum, module: ModuleEnum) => {
        return !!userAccess.find(item => item.permission === permission)?.modules.includes(module);
    };
    const canEdit = hasAccess(PermissionsEnum.Edit, ModuleEnum.Project);
    const canDeactivate = hasAccess(PermissionsEnum.Edit, ModuleEnum.Project);

    const tableHeader = [
        'PROJECT ID',
        'PROJECT NAME',
        'EARMARK QUANTITY (RM)',
        'MATURITY PERIOD (YEARS)',
        'STATUS',
        'CREATED AT',
        'ACTION',
    ];

    const tableBody = projectListing.map(project => {
        const {
            projectId,
            projectName,
            earmarkAmount,
            earmarkEndDate,
            status,
            updatedAt,
        } = project;

        const massagedData = [
            projectId,
            projectName,
            earmarkAmount.toFixed(2),
            earmarkEndDate,
            renderProjectStatusChip(status, ProjectAccStatusEnum[status]) || '-',
            updatedAt ? dateTimeFormat(updatedAt) : '-',
        ];

        const isDeactivated = status === ProjectAccStatusEnum.Deactivated;

        return [
            ...massagedData,
            (
                <div
                    key={projectId}
                    className={Styles['button-container']}
                >

                    <>
                        {canEdit
                            && (
                                <ActionButton
                                    label='Edit'
                                    onClick={() => handleEditprojectClick(projectId)}
                                />
                            )
                        }

                        {canDeactivate && !isDeactivated && (
                            <ActionButton
                                label='Deactivate'
                                onClick={() => handleStatusProjectClick(projectId)}
                                className={Styles.danger}
                            />
                        )}
                    </>
                </div>
            ),
        ];
    });

    return (
        <Table
            isLoading={isLoading}
            header={tableHeader}
            body={tableBody}
        />
    );
};

export default ProjectManagementTable;
